export const SET_O8_REQUEST = 'SET_O8_REQUEST';
export const SET_O8_FAILED = 'SET_O8_FAILED';
export const SET_O8_MISSION_STATEMENT_SUCCESS = 'SET_O8_MISSION_STATEMENT_SUCCESS';
export const CLEAN_O8 = 'CLEAN_O8';
